import PriceWeightUnitEnum from "@/constants/enums/PriceWeightUnitEnum";
import * as z from "zod";

export const ContractOrderDetailSchema = (closedLoopRemainingAmount?: number, shouldCheckClosedLoop?: boolean) =>
  z
    .object({
      amount: z.number({ message: "validation:amountRequired" }).min(0.00000001, "validation:amountRequired"),
      unit: z.number({ message: "validation:weightUnitRequired" }),
      created: z.date({ message: "validation:dateRequired" }),
      batchNumber: z.string().optional(),
    })
    .superRefine(({ amount, unit }, refinementContext) => {
      if (closedLoopRemainingAmount && shouldCheckClosedLoop) {
        const amountInTon = unit === PriceWeightUnitEnum.KG ? amount / 1000 : amount;
        if (closedLoopRemainingAmount === 0 || amountInTon > closedLoopRemainingAmount) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "validation:orderFromContract.amountLeftOnProductTooSmall",
            path: ["amount"],
          });
        }
      }
    });

export type ContractOrderDetailsFormInput = z.infer<ReturnType<typeof ContractOrderDetailSchema>>;
